import { useState } from "react";
import { EyeOff, Eye } from "lucide-react";

export const AuthInput = ({ label, type, placeholder, value, onChange, icon: Icon, isLight }) => {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';

  return (
    <div className="mb-6 group">
      <label className="text-[9px] uppercase tracking-[0.25em] text-slate-500 mb-2 block font-bold">
        {label}
      </label>
      <div className="relative">
        <div className="absolute left-0 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-cyan-500 transition-colors">
          <Icon size={14} />
        </div>
        <input 
          type={isPassword ? (show ? 'text' : 'password') : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`w-full bg-transparent border-b py-3 pl-7 pr-10 outline-none transition-all font-mono text-sm ${
            isLight ? 'border-slate-200 text-slate-900 focus:border-slate-900' : 'border-white/10 text-white focus:border-white'
          }`}
        />
        {isPassword && (
          <button 
            type="button"
            onClick={() => setShow(!show)}
            className="absolute right-0 top-1/2 -translate-y-1/2 text-slate-500 hover:text-white"
          >
            {show ? <EyeOff size={14} /> : <Eye size={14} />}
          </button>
        )}
      </div>
    </div>
  );
};